import type { ProToolType } from "@/features/tools/proToolTypes";

export type ToolPageMetadata = {
  toolType: ProToolType;
  route: string;
  title: string;
  label: string;
  intro: string;
  benefit: string;
  emptyResultsMessage: string;
};

export const toolPageMetadata: Record<ProToolType, ToolPageMetadata> = {
  launch_readiness_checker: {
    toolType: "launch_readiness_checker",
    route: "/tools/launch-readiness",
    title: "Launch Readiness Checker",
    label: "Launch readiness",
    intro:
      "Get a scored readiness report with launch blockers, ready signals, and a recommended next step.",
    benefit:
      "Know exactly where your blueprint stands before you start sending traffic or showing it to real users.",
    emptyResultsMessage:
      "No Launch Readiness results yet. Run the checker against a generated blueprint to see your saved results here.",
  },
  monetisation_model_suggester: {
    toolType: "monetisation_model_suggester",
    route: "/tools/monetisation-model",
    title: "Monetisation Model Suggester",
    label: "Monetisation",
    intro:
      "Identify the best-fit pricing model, first offer structure, and positioning angle for your app.",
    benefit:
      "Choose a practical first offer model and price direction — so you know how to monetise before you build.",
    emptyResultsMessage:
      "No Monetisation results yet. Choose a blueprint and generate your first monetisation recommendation.",
  },
  sales_page_headline_generator: {
    toolType: "sales_page_headline_generator",
    route: "/tools/sales-headlines",
    title: "Sales Page Headline Generator",
    label: "Sales headlines",
    intro:
      "Generate multiple sales-page headline angles, including a recommended top pick and positioning notes.",
    benefit:
      "Turn your blueprint into sharper buyer-facing headline options — ready for a sales page or campaign.",
    emptyResultsMessage:
      "No Sales Headline results yet. Generate headline angles from a blueprint to save them here.",
  },
};

export const toolPageOrder: ProToolType[] = [
  "launch_readiness_checker",
  "monetisation_model_suggester",
  "sales_page_headline_generator",
];

export function getToolRoute(toolType: ProToolType): string {
  return toolPageMetadata[toolType].route;
}
